import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class CompaniesIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/empresas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/empresa/editar/' + cell;
    
    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        {(row.active === 1) ?
          <button className="btn btn-sm btn-success" value={cell} onClick={() => this.archive(row.id)}><i className="fa fa-fw fa-power-off"></i></button>
          :
          <button className="btn btn-sm btn-danger" value={cell} onClick={() => this.activate(row.id)}><i className="fa fa-fw fa-power-off"></i></button>
        }
      </div>
    );

    return botao;
  }

  // Fetch ativando um item
  activate(id) {
    var confirm = window.confirm(this.locale.Empresas.ListaDeEmpresas.ativar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/ativar/' + id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  archive(id) {
    var confirm = window.confirm(this.locale.Empresas.ListaDeEmpresas.arquivar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/desativar/' + id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Empresas.ListaDeEmpresas.titulo}</h3>
      <Link to="/empresa/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.Empresas.ListaDeEmpresas.botaoAdicionarEmpresa}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há empresas cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Empresas.ListaDeEmpresas.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Empresas.ListaDeEmpresas.tabela.RazaoSocial}</TableHeaderColumn>

        <TableHeaderColumn dataField="abbreviation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Empresas.ListaDeEmpresas.tabela.Trigrama}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Empresas.ListaDeEmpresas.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default CompaniesIndex;



// WEBPACK FOOTER //
// ./src/Components/Companies/CompaniesIndex.js